
//default data
const config = {

    api: "https://chadsteele-slync-twitter-client.netlify.app/.netlify/functions/tweets",

    items: [
        { id_str: '1250960715579641857' },
        { id_str: '1250558928561352704' },
        { id_str: '1250895001636216837' },
    ],

    refresh: 5 * 60 * 1000,

}

export default config;